import {db} from './firebase.js';
function addItem(props, redirect) {
	var self = this;
	var redirect = redirect || false;
	var data = {};
	var item = self.$store.state.itemCollection[props.mod].find(function(el){return el.name == props.item;});
	var ingredients = [];
	var key = item.recipe.key;
	for (var prop in key) {
		var meta = key[prop].meta;
		meta = (meta != undefined) ? meta : '0';
		meta = (meta == '') ? '0' : meta;
		if (key[prop].item.split(':').length < 3) {
			key[prop].item = key[prop].item + ':' + meta;
		};
		ingredients.push(key[prop].item);
	};
	data.author = this.$store.state.user.uid;
	data[props.item] = {
		count: item.recipe.count,
		mod: props.mod,
		key: key,
		pattern: item.recipe.pattern,
		customPrice: 0,
		recipePrice: 0,
		priceType: 'customPrice',
		ingredients: ingredients,
	};
	// console.log(data);
	var doc = db.collection('mods').doc(props.mod).collection('recipes').doc(this.$store.state.user.uid);
	doc.update(data).then(function(){
		if (redirect) {
    		self.$notify({title: 'Успех', message: 'Предмет успешно добавлен в коллекцию', type: 'success'});
			self.$router.push({name: 'edit item', params: {item: props.item}});
		};
	}).catch((error) => {
		data.rating = 0;
    	doc.set(data).then(function(){
    		self.$notify({title: 'Успех', message: 'Предмет успешно добавлен в коллекцию', type: 'success'});
			if (redirect) {
				self.$router.push({name: 'edit item', params: {item: props.item}});
			};
		});
    });
};
var modsList = [
	{label: 'Minecraft 1.7.10', text: 'Minecraft 1.7.10', value: 'minecraft-1.7.10'},
	{label: 'Industrial Craft 2', text: 'Industrial Craft 2', value: 'industrial-craft-2'},
	{label: 'Applied Energistics 2', text: 'Applied Energistics 2', value: 'applied-energistics-2'},
	{label: 'Applied Energistics 2 Stuff', text: 'Applied Energistics 2 Stuff', value: 'applied-energistics-2-stuff'},
	{label: 'Advanced Solar Panels 3', text: 'Advanced Solar Panels 3', value: 'advanced-solar-panels-3'},
	{label: 'Advanced Machines', text: 'Advanced Machines', value: 'advanced-machines'},
	{label: 'IC2 Nuclear Control 2', text: 'IC2 Nuclear Control 2', value: 'ic-2-nuclear-control-2'},
	{label: 'Thermal Expansion 4', text: 'Thermal Expansion 4', value: 'thermal-expansion-4'},
	{label: 'Thermal Foundation', text: 'Thermal Foundation', value: 'thermal-foundation'},
	{label: 'Thermal Dynamics', text: 'Thermal Dynamics', value: 'thermal-dynamics'},
	{label: 'Ender IO', text: 'Ender IO 5', value: 'ender-io-5'},
	{label: 'Mekanism', text: 'Mekanism 9', value: 'mekanism-9'},
	{label: 'Mekanism Tools', text: 'Mekanism Tools', value: 'mekanism-tools'},
	{label: 'Mekanism Generators', text: 'Mekanism Generators', value: 'mekanism-generators'},
	{label: 'Gravitation Suite', text: 'Gravitation Suite', value: 'gravitation-suite'},
	// {label: '', text: '', value: ''},
];
function setFilterAndSort() {
	var self = this;
	var tableName = self.tableName;
	var options = self.$store.state.tableOptions.find(function(el){
		return el.tableName == tableName;
	});
  	if (options.filter.value.length > 0) {
	  	var hasCustomFilters = false;
	  	self.filters.forEach((el)=>{
	  		if (options.filter.value.indexOf(el.value) > -1) {	
	  			hasCustomFilters = true;
	  			return false;
	  		};
	  	});
		if (!hasCustomFilters && self.filters[0]) {
			options.filter.value = [self.filters[0].value];
		};
	};
  	var typeColumn = self.$refs[tableName].$refs.elTable.columns.find(col => col.property === options.filter.colProp);
  	typeColumn.filteredValue = options.filter.value;
  	self.$refs[tableName].$refs.elTable.store.commit('filterChange', {
    	column: typeColumn,
    	values: options.filter.value,
  	});
  	self.$refs[tableName].$refs.elTable.store.updateAllSelected();
  	self.currentFilters = [{prop: 'mod', value: options.filter.value}];
  	self.$refs[tableName].$refs.elTable.store.commit('sort', {	
    	prop: options.sort.prop,
    	order: options.sort.order,
  	});
  	self.page = options.page;
  	self.pageSize = options.pageSize;	
};
function filterChange() {
	var self = this;
	var tableName = self.tableName;
	var tableOptions = self.$store.state.tableOptions;
	var options = self.$store.state.tableOptions.find(function(el){
		return el.tableName == tableName;
	});
	var typeColumn = self.$refs[tableName].$refs.elTable.columns.find(col => col.property === options.filter.colProp);
	self.currentFilters = [];
	tableOptions.forEach(function(el, i){
		if (el.tableName == tableName) {
			tableOptions[i].filter.value = typeColumn.filteredValue;
			self.currentFilters.push({prop: 'mod', value: typeColumn.filteredValue});
		};
	});
	self.$store.commit('updateTableOptions', {tableOptions: tableOptions});
};
function sortChange(val) {
	var self = this;
	var tableName = self.tableName;
	var tableOptions = self.$store.state.tableOptions;
	var options = self.$store.state.tableOptions.find(function(el){
		return el.tableName == tableName;
	});
	tableOptions.forEach(function(el, i){
		if (el.tableName == tableName) {
			tableOptions[i].sort.order = val.order;
			tableOptions[i].sort.prop = val.prop;
		};
	});
	self.$store.commit('updateTableOptions', {tableOptions: tableOptions});
};
function currentPageChange(page){
	var self = this;
	var tableOptions = self.$store.state.tableOptions;
	tableOptions.forEach(function(el){
		if (el.tableName == self.tableName) {
			el.page = page;
		};
	});	
	self.$store.commit('updateTableOptions', {tableOptions: tableOptions});
};
function sizeChange(size){
	var self = this;
	var tableOptions = self.$store.state.tableOptions;
	tableOptions.forEach(function(el){
		if (el.tableName == self.tableName) {
			el.pageSize = size;
		};
	});	
	self.$store.commit('updateTableOptions', {tableOptions: tableOptions});
};
export { addItem, 
	modsList, 
	setFilterAndSort, 
	filterChange, 
	sortChange, 
	currentPageChange, 
	sizeChange,
};
